import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxSonnerToaster } from 'ngx-sonner';
import { ToastService } from './services/toast.service';
import { TokenService } from '../core/token.service';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-root',
    imports: [RouterOutlet, NgxSpinnerComponent, NgxSonnerToaster],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],})
export class AppComponent implements OnInit {
  private readonly document = inject(DOCUMENT);
  title = 'vas-demo';

  constructor(
    public authService: AuthService, 
    private router: Router,
    private spinner: NgxSpinnerService,
    private toastr: ToastService,
    public tokenService : TokenService
  ) {}

  ngOnInit(): void {
    this.document.getElementById('app-startup-loader')?.remove();
    this.checkLoginStatus();
  //  console.log("CAlled me")
      // this.toastr.success('Customer code created successfully','',{
      // });
    //  this.spinner.show('main');
  }

  private checkLoginStatus(): void {
  //  console.log('checkLoginStatus')
    if (this.tokenService.isLoggedIn()) {
      // console.log('hello looged in')
      // let user = this.encryptionService.getFromLocalStorage('username')
      // this.toastr.info('Hello '+user+'!', 'Welcome to VAS!');
    }      
  }
}
